<template>
  <collapsible-section
    :id="`step_${section.workflowStep.client_id}-${dropdownControlId}`"
    :control-name="`${section.workflowStep.titleOrDefault}Collapse`"
    :is-open="false"
  >
    <template #section-header>
      {{ section.workflowStep.titleOrDefault }}
    </template>

    <template #section-contents>
      <workflow-step-data
        :q="q"
        :handler="handler"
        :parent-tree-context="parentTreeContext"
        :section="section"
        @select="select"
      />

      <section-fields
        v-if="handler.usersOnly"
        :q="q"
        :handler="handler"
        :section="handler.formWorkflowStepUserSection(section.workflowStep)"
        icon-glyph="member"
        @select="select"
        :select-additional-parameters="[handler.formUserSection(section.workflowStep).type, section.workflowStep]"
      />
    </template>
  </collapsible-section>
</template>

<script lang="ts">
  import Vue from 'vue';
  import WorkflowStepData from '~/components/dynamicFieldsTrees/handlerComponents/workflow-step-data.vue';
  import SectionFields from '~/components/dynamicFieldsTrees/handlerComponents/common/section-fields.vue';
  import handlerComponentsMixin from '~/components/dynamicFieldsTrees/mixins/handlerComponentsMixin';
  import handlerTreeContextMixin from '~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin';
  import FormElementDynamicFieldsHandler from '~/models/dynamicFields/handlers/formElementDynamicFieldsHandler';
  import { IFormDynamicFieldSection } from '~/interfaces/dynamicFieldsInterfaces';

  export default Vue.extend({
    mixins: [
      handlerComponentsMixin,
      handlerTreeContextMixin,
    ],
    components: {
      WorkflowStepData,
      SectionFields,
    },
    props: {
      handler: {
        type: Object as () => FormElementDynamicFieldsHandler,
        required: true,
      },
      section: {
        type: Object as () => IFormDynamicFieldSection,
        required: true,
      },
    },
  });
</script>